import React from 'react';
import { PlayerContext } from './player';
import { uuid } from '../types/common-helper';
import { TeamStateFull } from '../types/state';
import { getFromStore, putToStore } from '../utils/indexedDB';

const TeamContext = React.createContext<
  [
    initialState: TeamContextState,
    setState: React.Dispatch<React.SetStateAction<TeamContextState>>
  ]
>([{}, () => {}]);

interface TeamStateProviderProps {
  gameCode: string;
  children: React.ReactNode;
}

const TeamStateProvider = ({ gameCode, ...props }: TeamStateProviderProps) => {
  const [player] = React.useContext(PlayerContext);
  const [state, setState] = React.useState<TeamContextState>({
    gameCode
  });

  const teamCode = player.playerState?.teamCode;

  React.useEffect(() => {
    const loadTeamState = async () => {
      const team = await getFromStore<TeamContextState>('team-state', gameCode);
      if (team && team.teamState) {
        setState(team);
      } else {
        const content: TeamContextState = {
          gameCode,
          teamState: BuildNewTeamState(gameCode)
        };
        setState(content);
        putToStore('team-state', content);
      }
    };

    if (teamCode) loadTeamState();
  }, [gameCode, teamCode]);

  return (
    <TeamContext.Provider value={[state, setState]}>
      {props.children}
    </TeamContext.Provider>
  );
};

export interface TeamContextState {
  gameCode?: string;
  teamState?: TeamStateFull;
}

export const BuildNewTeamState = (gameCode: string): TeamStateFull => {
  return {
    code: uuid(),
    name: '',
    avatarImage: '',
    status: 'waiting',
    score: 0,
    coordinates: {
      latitude: 0,
      longitude: 0
    },
    location: '',
    zones: [],
    areas: [],
    inventory: [],
    titles: [],
    timers: []
  };
};

export { TeamContext, TeamStateProvider };
